module.exports = __webpack_public_path__ + "img/news_1.9c6107ce.jpg";